import React from 'react'
import classnames from 'classnames'
import _ from 'lodash'

export default function CustomSteps({ steps, children, currentStep, onStepClick, visited, isEdit }) {
    return (
        <div className="custom-steps">
            <div className="steps-background">
                <div className="steps-list">
                    {
                        steps.map((step, i) => <Step name={step} index={i} key={`${step}-${i}`} currentStep={currentStep} onStepClick={(isEdit || visited[i]) && onStepClick} />)
                    }
                </div>
            </div>
            <div className="step-content">
                {children}
            </div>
        </div>
    )
}

function Step({ name, index = 0, currentStep, onStepClick }) {
    const completed = currentStep > index;
    return (
        <div data-index={index} className={classnames("step", { current: currentStep === index, completed, clickable: _.isFunction(onStepClick) })} onClick={onStepClick}>
            <div className="step-indicator">
                {/* {!completed ? (index + 1) : <CheckIcon />} */}
                {index + 1}
            </div>
            <span>
            {name}
            </span>
        </div>
    )
}